import HomeView from '@/shared/home/views/HomeView.vue';

const initial = [
    {
        path: '/',         
        label: 'Inicio',         
        name: 'home',    
        show: true, 
        component: HomeView },
    {
        path: '/login',    
        label: 'Ingresar', 
        name: 'login',    
        show: true,
        component: () => import('@/login/views/LoginView.vue') 
    },
    {
        path: '/register', 
        label: 'Regístrate',     
        name: 'register', 
        show: true,
        component: () => import('@/register/views/RegisterView.vue') 
    },
    {
        path: '/password-reset', 
        label: 'Recuperar contraseña',
        name: 'password_reset', 
        show: false,
        component: () => import('@/login/views/PasswordReset/index.vue') 
    },
    {
        path: '/has-token-expired/:token', 
        label: 'Validar token',
        name: 'has_token_expired', 
        show: false,
        component: () => import('@/login/views/PasswordReset/hasTokenExpired.vue') 
    },
    {
        path: '/privacy-policy', 
        label: 'Política de Privacidad',
        name: 'privacy_policy', 
        show: false,
        component: () => import('@/legal/views/PrivacyPolicy.vue'),
        meta: { hideLayout: true }
    },
];

export default initial;